import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgViolinPlotsIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		strokeWidth: 1,
		fillRule: "evenodd",
		fillOpacity: .84,
		children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M3,6 L9.42857143,5 L15.6,4 L18.4285714,5 L21,6 L18.4285714,7 L15.6,8 L9.42857143,7 L3,6 Z M3,12 L6.6,11 L8.4,10 L12,11 L21,12 L12,13 L8.4,14 L6.6,13 L3,12 Z M3,18 L9.3,17 L12.9,16 L15.6,17 L21,18 L15.6,19 L12.9,20 L9.3,19 L3,18 Z" }) })
	})
});
export default SvgViolinPlotsIcon;
